import { IconButton, IconButtonProps } from '@mui/material';
import { useCallback, type FocusEvent } from 'react';

export default function OpenPickerButton(props: IconButtonProps) {
  const { onBlur, onFocus } = props;

  // Don't propagate focus events to parent text field to prevent it from receiving focus
  // momentarily. This will prevent the text field helper text from showing field error
  // when the field is not yet touched.
  const handleFocus = useCallback(
    (event: FocusEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      onFocus?.(event);
    },
    [onFocus],
  );

  const handleBlur = useCallback(
    (event: FocusEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      onBlur?.(event);
    },
    [onBlur],
  );

  return <IconButton {...props} onFocus={handleFocus} onBlur={handleBlur} />;
}
